export const queryWebNotificationsByUserIdTypeIndex = `query QueryWebNotificationsByUserIdTypeIndex(
  $userId: ID!
  $type: String!
  $first: Int
  $after: String
) {
  queryWebNotificationsByUserIdTypeIndex(
    userId: $userId
    type: $type
    first: $first
    after: $after
  ) {
    items {
      id
      type
      status
      userId
      user {
        id
        userGroupId
        company {
          id
          name
        }
        emailAddress
        employeeId
        subCompanyId
        subCompany {
          id
          name
        }
        avatar {
          bucket
          region
          key
        }
        firstName
        lastName
      }
      referralId
      referral {
        id
        user {
          id
          emailAddress
          employeeId
          firstName
          lastName
          incentiveEligible
        }
        contact {
          id
          firstName
          lastName
        }
      }
      jobId
      matches
      message
      job {
        id
        title
        companyId
        createdBy {
          id
          firstName
          lastName
        }
        departmentId
        department {
          id
          name
        }
        hiringManagerId
        location
        referrals {
          id
          contactId
        }
        referralBonus
        tieredBonus {
          id
          name
          tiers
        }
        subCompanyId
        subCompany {
          id
          name
        }
      }
      dateCreated
      contactId
      contact {
        id
        firstName
        lastName
        emailAddress
        socialMediaAccounts
      }
      referralRequestedStatus
      requestingUserId
      requestingUser {
        id
        firstName
        lastName
        avatar {
          bucket
          region
          key
        }
      }
      questionsData
    }
    nextToken
  }
}
`;
